export default __webpack_public_path__ + "static/media/home-8.ba64e931.jpg";